export default __webpack_public_path__ + "static/media/marie-odwayo-rounded.44f88f01.png";